import React from "react"
import BoxPage from "../../../../../../components/v2/layout/boxPage/boxPage"
import { useIdParam } from "../../../../../../hooks/useIdParam"
import SchoolCalendarPicker from "../../../../../../components/v2/inputs/pickers/schoolCalendarPicker"
import SegmentPicker from "../../../../../../components/v2/inputs/pickers/segmentPicker"
import SectionPicker from "../../../../../../components/v2/inputs/pickers/sectionPicker"

const SchoolScheduleLearners = () => {
  const groupId = useIdParam("groupId")

  const [filters, setFilters] = React.useState({
    schedule: null,
    grade: null,
    segment: null,
    section: null,
  })
  const [filterErrors, setFilterErrors] = React.useState({
    schedule: false,
    grade: false,
    segment: false,
    section: false,
  })

  const onFilterChange = (name) => (event) => {
    setFilters({
      ...filters,
      [name]: event.target.value,
    })
    setFilterErrors({
      ...filterErrors,
      [name]: !event.target.value,
    })
  }

  return (
    <BoxPage title={"Learner schedule"}>
      <div className={"mb20"}>
        <SchoolCalendarPicker
          groupId={groupId}
          value={filters.schedule}
          hasError={filterErrors.schedule}
          onChange={onFilterChange("schedule")}
        />
        <SegmentPicker
          onChange={onFilterChange("segment")}
          hasError={filterErrors.segment}
          value={filters.segment}
          scheduleId={filters.schedule?.id}
          isWaitingForOtherFieldsMessage={"First select grade"}
        />
        <SectionPicker
          onChange={onFilterChange("section")}
          hasError={filterErrors.section}
          value={filters.section}
          segmentId={filters.segment?.id}
        />
      </div>
      <div>table</div>
    </BoxPage>
  )
}

export default SchoolScheduleLearners
